/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const scenarioChangeSummarySchema = z.object({
  configurationChanges: z.int(),
  dependencyChanges: z.int(),
  itemsAdded: z.int(),
  itemsDeleted: z.int(),
  itemsUpdated: z.int(),
});
